module.exports = __webpack_public_path__ + "img/sheet-color-icon.6260408a.svg";